import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { GlobalUiModule } from "@obg/ngx.ui.global";

import { AccordionHeaderComponent } from "./accordion-header.component";

const DIRECTIVES: any[] = [AccordionHeaderComponent];

@NgModule({
	imports: [CommonModule, TranslateModule, GlobalUiModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class AccordionHeaderModule {}
